const state = {
  loadBalancerDetail: {},
  planType: '',
  price: {},
  newPrice: {},
};

const getters = {
  loadBalancerDetail(state) {
    return state.loadBalancerDetail;
  },
  planType(state) {
    return state.planType;
  },
  price(state) {
    return state.price;
  },
  newPrice(state) {
    return state.newPrice;
  }
};

const actions = {
  updateLoadBalancer({ commit }, loadBalancerDetail) {
    commit('UPDATE_LOAD_BALANCER', loadBalancerDetail);
  },
  updatePrice({ commit }, price) {
    commit('UPDATE_PRICE', price);
  },
  updateNewPrice({ commit }, newPrice) {
    commit('UPDATE_NEW_PRICE', newPrice);
  },
  updatePlanType({ commit }, planType) {
    commit('UPDATE_PLAN_TYPE', planType);
  }
};

const mutations = {
  UPDATE_LOAD_BALANCER(state, loadBalancerDetail) {
    state.loadBalancerDetail = loadBalancerDetail;
  },
  UPDATE_PRICE(state, price) {
    state.price = price;
  },
  UPDATE_NEW_PRICE(state, newPrice) {
    state.newPrice = newPrice;
  },
  UPDATE_PLAN_TYPE(state, planType) {
    state.planType = planType;
  }
};

export default {
  state,
  actions,
  mutations,
  getters,
};
